<template>
    <div>
        <!-- dialog -->
        <v-dialog v-model="dialog" persistent max-width="400" @keydown.esc="dialog = false" >
            <v-card>
                <div class="d-flex py-1 primary">
                    <v-card-title
                        class="text-uppercase flex-grow-1 text-subtitle-1 justify-center pa-0 white--text"
                    >
                        {{ !itemId ? $t('add') : $t('edit') }}
                    </v-card-title>

                    <v-btn icon @click="dialog = false">
                        <v-icon color="white"> mdi-close-circle-outline </v-icon>
                    </v-btn>
                </div>

                <v-card-text class="pt-2 px-3 pb-0">
                    <v-row dense class="ma-0">
                        <v-col>
                            <v-text-field 
                                v-model="name"
                                outlined
                                dense
                                hide-details
                                :label="$t('inputs.name')"
                            ></v-text-field>
                        </v-col>

                        <v-col>
                            <v-autocomplete 
                                v-model="priceId"
                                :items="pricesTypes"
                                item-text="name"
                                item-value="id"
                                outlined
                                dense
                                hide-details
                                :label="$t('inputs.price-type')"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn
                        @click="submit()"
                        text
                        color="success"
                        :loading="submitLoading"
                    >
                        {{$t('save')}}
                    </v-btn>
                    <v-btn
                        text
                        :disabled="submitLoading"
                        @click="dialog = false"
                    >
                        {{$t('cancel')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- delete dialog -->
        <delete-dialog ref="deleteDialog" @on-delete="getAll">
            <p class="mb-0 text-body-1">
                {{ $t('are-you-sure-you-want-to') }} <span class="red--text">{{ $t('delete') }}</span> {{$t('type')}} {{$t('?')}}
            </p>
        </delete-dialog>

        <v-row class="mb-1">
            <v-spacer />
            <v-col class="d-flex justify-end">
                <v-btn @click="dialog = true" small color="success">
                    {{$t('customersTypes.add-a-new-customer-type')}}
                </v-btn>
            </v-col>
        </v-row>

        <bee-handy-table
            :items="customersTypes"
            :headers="headers"
            :loading="loading"
            hide-default-footer
            :items-per-page="-1"
            dense
            zebra
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <v-btn small icon @click="itemId = item.id; dialog = true" color="edit-color">
                        <v-icon> mdi-pencil </v-icon>
                    </v-btn>

                    <v-btn 
                        small 
                        icon 
                        color="alert-color" 
                        @click="$refs.deleteDialog.activeDeleteDialog(item.id, 'entityType')"
                    >
                        <v-icon> mdi-delete </v-icon>
                    </v-btn>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>
<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import { mapState } from 'vuex'
export default {
    components: {
        DeleteDialog
    },

    data () {
        return {
            dialog: false,
            name: null,
            priceId: null,
            itemId: null,
            loading: false,
            submitLoading: false
        }
    },

    watch: {
        dialog (val) {
            if (val) {
                if (this.itemId !== null) {
                    this.name = this.customersTypes.find(c => c.id === this.itemId)?.name
                    this.priceId = this.customersTypes.find(c => c.id === this.itemId)?.priceId
                } 
            } else {
                this.name = null
                this.priceId = null
                this.itemId = null
            }
        }
    },

    computed: {
        ...mapState({
            customersTypes: state => state.entityType.customersTypes,
            pricesTypes: state => state.pricesTypes.pricesTypes
        }),
        headers () {
            return [
                {
                    text: 'Name',
                    name: 'name',
                    value: 'name'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    noInput: true
                }
            ]
        },
    },

    methods: {
        getAll() {
            this.loading = true
            this.$store.dispatch('entityType/fetchAll').finally(() => {
                this.loading = false
            })
        },

        submit () {
            this.submitLoading = true
            const actionName = !this.itemId ? 'create' : 'update'
            this.$store.dispatch(`entityType/${actionName}`, { 
                name: this.name, 
                priceId: this.priceId,
                id: this.itemId
            }).then(() => {
                this.getAll()
                this.dialog = false
            }).finally(() => {
                this.submitLoading = false
            })
        }
    },

    created () {
        if (!this.pricesTypes.length) this.$store.dispatch('pricesTypes/fetchAll')
        this.getAll()
    }
}
</script>
